import React from "react"
import { Switcher } from "../../../../@shared/elements/switcher";
import { filterAreas } from "./mock";
export const Switching = () => (
    <ul className="switching">
        {filterAreas.map((item,i)=>(
            <li key={`area-${i}`}> <label> <Switcher /> <p> {item.title} </p> </label> </li>

        ))}
    </ul>
)

